<template>

  <Dialog v-model:visible="visible"
    :style="{ width: '600px', maxHeight: '90wh' }"
    :modal="true"
    :contentStyle="{'overflow': 'visible'}"
    ref="dialog"
    @show="onShow"
    @hide="onHide"
    >
    <template #header>
      <h2>{{title}}</h2>
    </template>

    <div class="p-fluid p-grid">
      <div class="p-field p-col-12 p-md-3 p-input-filled">
        <label for="number">Продуктов номер</label>
        <InputText :tabindex="-1" id="code" type="text" v-model="productNumber" readonly="true"/>
      </div>
      <div class="p-field p-col-12 p-md-9">
        <label for="name">Наименование</label>
        <AutoComplete v-model="product" :dropdown="true" field="name"
          :suggestions="products" @complete="searchProduct($event)" forceSelection
            placeholder="Въведете продукт" @itemSelect="onItemSelect">
            <template #item="props">
              {{props.item.number}} {{props.item.name}}
            </template>
        </AutoComplete>
      </div>
      <div class="p-field p-col-12 p-md-9">
        <label for="name">Партида</label>
        <AutoComplete v-model="data.batch" :dropdown="true" field="name"
          :suggestions="deliveries" @complete="searchDelivery($event)" forceSelection
            placeholder="Въведете партида">
            <template #item="props">
              <span>{{props.item.name}}</span>
                /
                &nbsp;<Badge class="p-overlay-badge" :value="props.item.quantity"/>
            </template>
        </AutoComplete>
        <!--
        <Dropdown v-model="data.batch" :options="deliveries" optionLabel="number" :showClear="true">
          <template #value="props">
            <div v-if="props.value">
              <span>{{props.value.number}}</span> / <span>{{new Date(props.value.date).toLocaleDateString()}}</span>
                /
                <span>{{props.value.contragent}}</span>
            </div>
            <span v-else>
              {{props.placeholder}}&nbsp;
            </span>
          </template>
          <template #option="props">
            <span>{{props.option.number}}</span> / <span>{{new Date(props.option.date).toLocaleDateString()}}</span>
              /
              <span>{{props.option.contragent}}</span>
              &nbsp;<Badge class="p-overlay-badge" :value="props.option.quantity"/>
          </template>
        </Dropdown>
        -->
      </div>
      <div class="p-field p-col-12 p-md-3 p-input-filled">
        <label for="availability">Наличност</label>
        <InputText v-model="availability" readonly/>
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="quantity">Количество</label>
        <InputNumber ref="quantity" id="quantity" v-model="data.quantity" :minFractionDigits="2" :maxFractionDigits="4"/>
      </div>
    </div>

    <template #footer>
      <ButtonsApplyCancel @apply="onSave" @cancel="$refs.dialog.close()"/>
    </template>
  </Dialog>

</template>

<script>

export default {
  emits: {
    load: null,
    save: null
  },
  data() {
    return {
      visible: false,
      selected: {},
      tabIndex: 0,
      products: [],
      deliveries: [],
      data: {
      }
    }
  },

  mounted() {
  },

  props: {
    title: String,
    hasVat : Boolean
  },

  methods: {
    searchProduct(event) {
      var ctx = this;
      this.$http.get('/product', {
        params: {
          query: event.query
        }
      }).then(res => ctx.products = res.data)
    },
    searchDelivery() {
      var ctx = this;
      if(this.data.product && this.data.product.id) {
        this.$http.get('/sale/items-available', {
          params: {
              product: this.data.product.id,
              store: this.sale.store.id,
              date: this.sale.date
          }
        }).then(res => ctx.deliveries = res.data)
      }
    },
    onShow() {
      var data = {};
      this.$emit('load', data);
      this.sale = data.sale;
      this.data = data.data;
      data.quantity = this.$utils.value(data.quantity);
      if (data.quantity == 0) {
        data.quantity = undefined;
      }
      data.price = this.$utils.value(data.price);
      if (data.price == 0) {
        data.price = undefined;
      }
    },
    onHide() {
      this.data = {}
    },
    onSave() {
      this.data.netto  = this.netto;
      this.data.vatPerc  = this.vatPerc;
      this.data.vat  = this.vat;
      this.data.total = this.total;
      this.$emit('save', this.data);
      this.$refs.dialog.close();
    },
    onItemSelect() {
    }
  },

  computed: {
    productNumber: function() {
      if (this.data.product) {
        return this.data.product.number;
      }
      return "";
    },
    productName: function() {
      if (this.data.product) {
        return this.data.product.name;
      }
      return "";
    },
    product: {
      get() {
        return this.data.product;
      },
      set(product) {
        this.data.product = product;
        this.data.price = this.$utils.value(product.priceRetail);
        this.data.quantity = 1;
        this.data.batch = {};
        this.deliveries = [];
      }
    },
    availability() {
      if (this.data.batch) {
        return this.data.batch.quantity;
      }
      return null;
    },
    netto: function() {
      var netto = this.$utils.value(this.data.quantity) *  this.$utils.value(this.data.price);
      var discount = netto * this.$utils.value(this.data.vatPerc) / 100;
      return netto - discount;
    },
    vatPerc: function() {
      return this.hasVat ? this.$utils.value(this.data.vatPerc) : 0;
    },
    vat: function() {
      return this.netto * (this.vatPerc / 100);
    },
    total: function() {
      return this.netto + this.vat;
    }
  }
}
</script>
